import { render } from "./WalletReport.vue?vue&type=template&id=491927ec"
import script from "./WalletReport.vue?vue&type=script&lang=js"
export * from "./WalletReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__